/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/userAttributes/userAttributesTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/userAttributes/userAttributesTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export let UserAttributeKeys;

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/userAttributes/userAttributesTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
(function (UserAttributeKeys) {
  UserAttributeKeys["PREAPPLIED_FILTER_CHANGED"] = "Academy:LanguageFilter:preappliedFilterChanged";
  UserAttributeKeys["DONT_SHOW_AGAIN"] = "Academy:LanguageFilter:dontShowAgain";
  UserAttributeKeys["HAS_VIEWED_PLAYLIST"] = "Academy:Playlists:hasViewedPlaylist";
  UserAttributeKeys["HAS_VIEWED_SHORT_SURVEY"] = "Academy:Shorts:hasViewedSurvey";
  UserAttributeKeys["WIZARD_DONT_SHOW_AGAIN"] = "Academy:Wizard:dontShowAgain";
  UserAttributeKeys["WIZARD_RESULTS"] = "Academy:Wizard:wizardResults";
  UserAttributeKeys["WIZARD_COMPLETION_DATE"] = "Academy:Wizard:completionDate";
})(UserAttributeKeys || (UserAttributeKeys = {}));
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/userAttributes/userAttributesTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */